function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: "var(--radius, 43)",
    fill: "none",
    stroke: "rgba(255,255,255,0.98)",
    strokeWidth: "var(--stroke-width, 14)",
    strokeLinecap: "round",
    style: {
      strokeDasharray: "var(--arc-length, 205.43) var(--circumference, 270.18)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: "var(--radius, 43)",
    fill: "none",
    stroke: "#24C84D",
    strokeWidth: "var(--stroke-width, 14)",
    strokeLinecap: "round",
    style: {
      strokeDasharray: "var(--arc-length, 205.43) var(--circumference, 270.18)",
      strokeDashoffset: "var(--progress-offset, 0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCircle);
export default __webpack_public_path__ + "static/media/progress-circle.c362c45e57f90b9f88e1d96ee5492342.svg";
export { ForwardRef as ReactComponent };